var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as fromStore from '../../_store';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SPECIAL_CASE_MARKET_LANGUAGE_MAP, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET } from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
var FrequentFlyerComponent = /** @class */ (function () {
    function FrequentFlyerComponent(fb, store, router, ibeAdminConfigService) {
        var _this = this;
        this.fb = fb;
        this.store = store;
        this.router = router;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.displayValidationMessages = false;
        this.form = this.fb.group({
            FFid: [null],
            FFnum: [null],
            isCorporate: [null],
            tapCorporateNumber: [null]
        });
        this.isBookingPaymentPage = false;
        this.sub$ = new Subscription();
        this._hasChanges = new BehaviorSubject(false);
        this.frequentFlyerPrograms = [];
        this.TP_MILES_AND_GO_VALUE = 'TP';
        this.passengers = null;
        this.selectedPassenger = null;
        this.corporateProgramTypes = [
            { text: 'bookingDetails.label.tapCorporate', value: 'TP' },
            { text: 'bookingDetails.label.otherCorporate', value: 'other' }
        ];
        this.showCorpFields = false;
        this.INDRA_ffNumberUniqueValidator = function (control) {
            var ffNumber = control.value;
            if (ffNumber && _this.form.get('FFid').valid) {
                var FFid_1 = _this.form.get('FFid').value;
                var existingFFNumber = _this.passengers.find(function (passenger) {
                    if (passenger.idPax != _this.selectedPassenger.idPax && (ffNumber == passenger.FFnum && FFid_1 == passenger.FFid)) {
                        return true;
                    }
                    return false;
                });
                if (existingFFNumber) {
                    return { existing: true };
                }
            }
            return null;
        };
    }
    Object.defineProperty(FrequentFlyerComponent.prototype, "classViewOnlyForm", {
        get: function () {
            return Object.is('view', this.displayMode) ? 'sidebar__form--view-only' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrequentFlyerComponent.prototype, "hasErrorClassFFid", {
        get: function () {
            return this.form.get('FFid').invalid && this.form.get('FFnum').valid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrequentFlyerComponent.prototype, "hasErrorClassFFnum", {
        get: function () {
            return this.form.get('FFnum').invalid && this.form.get('FFid').valid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrequentFlyerComponent.prototype, "hasData", {
        get: function () {
            return !_.isEmpty(this.form.value);
        },
        enumerable: true,
        configurable: true
    });
    FrequentFlyerComponent.prototype.trackByFn = function (index, item) {
        return index;
    };
    Object.defineProperty(FrequentFlyerComponent.prototype, "hasChanges", {
        get: function () {
            return this._hasChanges.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    FrequentFlyerComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think/payment')) {
            this.isBookingPaymentPage = true;
        }
        this.sub$.add(this.store.select(fromStore.getSelectedFrequentFlyerPrograms).subscribe(function (data) {
            _this.frequentFlyerPrograms = data;
        }));
        this.sub$.add(this.store.select(fromStore.getSelectedPassengers).subscribe(function (data) {
            _this.passengers = data;
        }));
        this.sub$.add(this.store.select(fromStore.getSelectedPassengersAtIndex).subscribe(function (data) {
            _this.selectedPassenger = data;
            _this.form.patchValue(__assign({}, data), { emitEvent: false });
            if (_this.hasData && _this.form.valid) {
                _this.displayMode = _this.isBookingPaymentPage ? 'edit' : 'view';
                if (_this.form.controls['isCorporate'].value) {
                    _this.INDRA_toggleCorporateFields();
                }
            }
            else {
                _this.displayMode = 'edit';
            }
        }));
        this.sub$.add(this.form.valueChanges.subscribe(function () {
            _this._hasChanges.next(true);
            _this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateFrequentFlyer': true }));
        }));
        this.sub$.add(this.form.get('FFid').valueChanges.subscribe(function (newValue) {
            return _this.updateFrequentFlyerNumberValidation(newValue);
        }));
        this.sub$.add(this.form.get('FFnum').valueChanges.subscribe(function (newValue) {
            return _this.updateFrequentFlyerIDValidation(newValue);
        }));
    };
    FrequentFlyerComponent.prototype.updateFrequentFlyerNumberValidation = function (newFFid) {
        var ffNumControl = this.form.get('FFnum');
        if (Object.is(this.TP_MILES_AND_GO_VALUE, newFFid)) {
            ffNumControl.setValidators([
                Validators.required,
                Validators.pattern('[0-9]+'),
                Validators.maxLength(9),
                Validators.minLength(9),
                this.INDRA_ffNumberUniqueValidator,
            ]);
        }
        else if (!newFFid) {
            ffNumControl.clearValidators();
        }
        else {
            ffNumControl.setValidators([
                Validators.required,
                Validators.pattern('[a-zA-Z0-9]+'),
                this.INDRA_ffNumberUniqueValidator,
            ]);
        }
        ffNumControl.updateValueAndValidity({ emitEvent: false });
    };
    FrequentFlyerComponent.prototype.updateFrequentFlyerIDValidation = function (newFFNum) {
        var ffIDControl = this.form.get('FFid');
        if (newFFNum) {
            ffIDControl.setValidators([
                Validators.required
            ]);
        }
        else {
            ffIDControl.clearValidators();
        }
        ffIDControl.updateValueAndValidity({ emitEvent: false });
    };
    FrequentFlyerComponent.prototype.ngOnDestroy = function () {
        this.sub$.unsubscribe();
    };
    FrequentFlyerComponent.prototype.formFrequentFlyerErrors = function (control) {
        var errors = [];
        if (Object.is('FFnum', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.frequentFlyerDocumentNumRequired');
            }
            if (this.form.controls[control].hasError('pattern')
                || this.form.controls[control].hasError('maxlength') || this.form.controls[control].hasError('minlength')) {
                errors.push('bookingDetails.error.frequentFlyerDocumentNumPattern');
            }
            if (this.form.controls[control].hasError('existing')) {
                errors.push('bookingDetails.error.frequentFlyerDocumentNumExisting');
            }
        }
        if (Object.is('FFid', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.frequentFlyerFiscalNumRequired');
            }
        }
        if (Object.is('tapCorporateNumber', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.tapCorporateNumberRequired');
            }
            if (this.form.controls[control].hasError('pattern')
                || this.form.controls[control].hasError('maxlength') || this.form.controls[control].hasError('minlength')) {
                errors.push('bookingDetails.error.tapCorporateNumberInvalid');
            }
        }
        return errors.join('; ');
    };
    FrequentFlyerComponent.prototype.clearForm = function () {
        this.form.reset();
    };
    FrequentFlyerComponent.prototype.cancelEdit = function () {
        var _this = this;
        this.store.select(fromStore.getSelectedPassengersAtIndex)
            .pipe(take(1)).subscribe(function (data) {
            _this.form.reset(__assign({}, data), { emitEvent: false });
            _this._hasChanges.next(false);
        });
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateFrequentFlyer': false }));
        this.displayMode = 'view';
    };
    FrequentFlyerComponent.prototype.openEditForm = function () {
        this.displayMode = 'edit';
    };
    FrequentFlyerComponent.prototype.INDRA_gotoURL = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    FrequentFlyerComponent.prototype.INDRA_toggleCorporateFields = function () {
        this.showCorpFields = !this.showCorpFields;
        var ffCorpProgramNumber = this.form.get('tapCorporateNumber');
        if (this.showCorpFields) {
            ffCorpProgramNumber.setValidators([
                Validators.required,
                Validators.pattern('[a-zA-Z0-9]+'),
                Validators.maxLength(6),
                Validators.minLength(6)
            ]);
        }
        else {
            ffCorpProgramNumber.clearValidators();
            ffCorpProgramNumber.reset();
        }
        ffCorpProgramNumber.updateValueAndValidity({ emitEvent: false });
    };
    return FrequentFlyerComponent;
}());
export { FrequentFlyerComponent };
